import React, { useState, useCallback, Dispatch, SetStateAction } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';

// import { Container } from './styles';
interface DialogDelete {
  cdBaixaAdicional: string;
  populaTabela: () => void;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const DialogDeleteAdicionais: React.FC<DialogDelete> = ({
  cdBaixaAdicional,
  populaTabela,
  open,
  setOpen,
}) => {
  const [disabled, setDisabled] = useState(false);

  const { addToast } = useToast();

  const handleCloseConfirmation = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const deletaProduto = useCallback(() => {
    setDisabled(true);
    api
      .delete(`/baixa_adicionais/${cdBaixaAdicional}`)
      .then(() => {
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: `O insumo foi deletado com sucesso.`,
        });
        populaTabela();
        handleCloseConfirmation();
        setDisabled(false);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ocorreu um erro ao tentar deletar o insumo: '${error}'.`,
        });
        handleCloseConfirmation();
        setDisabled(false);
      });
  }, [addToast, cdBaixaAdicional, handleCloseConfirmation, populaTabela]);
  return (
    <Dialog
      open={open}
      onClose={handleCloseConfirmation}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Atenção!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Tem certeza que deseja deletar o insumo?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseConfirmation}
          style={{
            color: '#2c73e9',
          }}
        >
          CANCELAR
        </Button>
        <Button
          onClick={deletaProduto}
          disabled={disabled}
          style={{
            color: '#2c73e9',
          }}
        >
          DELETAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDeleteAdicionais;
